import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M30 5.625V6.125C30 6.5375 29.6625 6.875 29.25 6.875H2.75C2.3375 6.875 2 6.5375 2 6.125V5.625C2 5.2125 2.3375 4.875 2.75 4.875H29.25C29.6625 4.875 30 5.2125 30 5.625Z M22 15.75V16.25C22 16.6625 21.6781 17 21.2847 17H2.71535C2.32191 17 2 16.6625 2 16.25V15.75C2 15.3375 2.32191 15 2.71535 15H21.2847C21.6781 15 22 15.3375 22 15.75Z M16 26.375V25.875C16 25.4625 15.6617 25.125 15.2483 25.125H2.75168C2.33826 25.125 2 25.4625 2 25.875V26.375C2 26.7875 2.33826 27.125 2.75168 27.125H15.2483C15.6617 27.125 16 26.7875 16 26.375Z'],
  name: 'uiFilterAlt',
  oldName: 'culFilterAlt'
} as IconDefinition
